const TERMS_CONDITIONS_HREF = 'https://docs.dibscapital.com/Terms+of+Service.pdf'
const PRIVACY_POLICY_HREF = 'https://docs.dibscapital.com/Privacy+Policy.pdf'

const CASE_STUDY_HREF = "https://sb-footer.s3.amazonaws.com/The+Aspen+Coin+Case+Study.pdf";

export { TERMS_CONDITIONS_HREF, CASE_STUDY_HREF, PRIVACY_POLICY_HREF };
